import React from "react";
import { Link, useLocation } from "react-router-dom";
import { House, Gamepad2, Trophy, FileText, Users } from "lucide-react";

export function MobileBottomNav({ 
  isCollapsedMobile, 
  setIsCollapsedMobile, 
  onChatToggle 
}) {
  const location = useLocation();
  const path = location.pathname;

  const items = [
    { 
      key: "home", 
      label: "Home", 
      icon: House,
      to: "/",
      active: path === "/"
    },
    { 
      key: "casino", 
      label: "Casino", 
      icon: Gamepad2,
      to: "/casino",
      active: path.startsWith("/casino") || path.startsWith("/group")
    },
    { 
      key: "sports", 
      label: "Sports", 
      icon: Trophy,
      to: "/sports",
      active: path.startsWith("/sports")
    },
    { 
      key: "bets", 
      label: "My Bets", 
      icon: FileText,
      to: "/my-bets",
      active: path.startsWith("/my-bets")
    },
    { 
      key: "affiliate", 
      label: "Affiliate", 
      icon: Users,
      to: "/affiliate",
      active: path.startsWith("/affiliate")
    }
  ];

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-sidebar border-t border-gray-800/80 h-[64px] flex items-center justify-around px-2 shadow-lg">
      {items.map((it) => {
        const Icon = it.icon;
        const isActive = it.active;
        
        const content = (
          <div className="flex flex-col items-center justify-center flex-1 h-full relative">
            <Icon 
              className={`w-5 h-5 transition-colors duration-200 ${isActive ? "text-white" : "text-[#8e969f] group-hover:text-white"}`} 
              strokeWidth={isActive ? 2.5 : 2} 
            />
            <span className={`text-[11px] font-semibold mt-1 transition-colors duration-200 ${isActive ? "text-white" : "text-[#8e969f] group-hover:text-white"}`}>
              {it.label}
            </span>
            {isActive && (
              <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-[3px] bg-[#1fc16b] rounded-b-md" />
            )}
          </div>
        );

        if (it.to) {
          return (
            <Link 
              key={it.key} 
              to={it.to} 
              className="flex-1 h-full flex items-center justify-center group"
            >
              {content}
            </Link>
          );
        }

        return (
          <button 
            key={it.key} 
            onClick={it.onClick} 
            className="flex-1 h-full flex items-center justify-center group focus:outline-none"
          >
            {content}
          </button>
        );
      })}
    </nav>
  );
}

export default MobileBottomNav;
